import { render, staticRenderFns } from "./RewardIconEarned.vue?vue&type=template&id=44827c35&"
import script from "./RewardIconEarned.vue?vue&type=script&lang=js&"
export * from "./RewardIconEarned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports